export const environment = {
  production: true,

  // Arturo's sidebar entries (@see arturo-switch.utils): on in staging since 29/10, together with the
  // back-end module, for the first look at the pages
  arturoLive: true,

  // Entries of the 3.0.0 archive (@see archive-switch.utils): on in staging first, for the tests of
  // the switch (FEX-09); production stays off until they pass
  archiveV3Live: true,

  // API settings
  apiProtocol: "https://",
  apiHost: "staging.api.archedi.it",
  apiPort: "",
  apiVersion: "v2",

  // Suppliers API settings
  suppliersApiProtocol: "https://",
  suppliersApiHost: "staging.api.fornitori.archedi.it",
  suppliersApiPort: "",
  suppliersApiVersion: "v1",

  // Front-end settings
  frontEndProtocol: "https://",
  frontEndHost: "staging.wa.archedi.it",
  frontEndPort: "",
  cookieSecure: true,

  // Locales settings
  availableLangs: ["en", "it"],

  // Openapi
  openApiUsername: "info@studioassociatogamma.com",
  openApiPassword: "yghamydrzbcuitac86kr20vlsge9tvlc",

  // Creditsafe
  creditsafeUsername: "fabio.stangalini@sitisrl.it",
  creditsafePassword: "]o)@7m9L):gDIkN.D^vd",

  // Maps
  googleMapsApi: "AIzaSyAffU3wsz3cC6-BKC2ombpx2Hy9oRIZ6Yw",
};
